namespace('compass.group');

compass.group.ListLoaderTransferWidget = compass.defineWidget(function ListLoaderTransferWidget(options) {
     var me = this;
     var $j = jQuery;
     var d = jQuery.dom;
     var _settings = options;

     var _drawHeader = function() {
          var header = d.div({ className: 'header'}, _settings.labels.headerText);
          var groupName = d.div({ className: 'groupName'}, _settings.groupName);

          return [header, groupName];
     };

     var _drawSubHeader = function() {
          var subHeader = d.div({ className: 'subHeader'}, _settings.labels.subHeaderText);

          return subHeader;
     };

     var _drawInstructions = function() {
          var instructions = d.ol({ className: 'instructions'},
               d.li({ className: 'instructionText'}, _settings.labels.instructionOneText),
               d.li({ className: 'instructionText'}, _settings.labels.instructionTwoText),
               d.li({ className: 'instructionText'}, _settings.labels.instructionThreeText),
               d.li({ className: 'instructionText'}, _settings.labels.instructionFourText),
               d.li({ className: 'instructionText'}, _settings.labels.instructionFiveText)
          );
          var note = d.div( {className: 'note'}, d.span({ className: 'noteTitle'}, 'NOTE: '), _settings.labels.noteText);

          return [instructions, note];
     };

     var _drawDownloadOnlyInstructions = function() {
          var instructions = d.div({ className: 'instruction'},
               d.div({ className: 'instructionTitleText'}, _settings.labels.downloadOnlyTitleText),
               d.div({ className: 'instructionDetailsText'}, _settings.labels.downloadOnlyDetailsText)
          );
          return instructions;
     };

     var _drawListLoaderDisabledInstructions = function() {
          var instructions = d.div({ className: 'instruction'},
               d.div({ className: 'instructionTitleText'}, _settings.labels.listLoaderDisabledTitleText),
               d.div({ className: 'instructionDetailsText'}, _settings.labels.listLoaderDisabledDetailsText)
          );
          return instructions;
     };

     var _drawCancelButton = function() {
          var cancelButton = d.input({ className: 'cancelSubmission secondaryButton', value: _settings.labels.cancelButtonText}).activate(function() {
               $j('.ListLoaderDialog').remove();
          });

          return cancelButton;
     };

     var _drawDownloadButton = function() {
          var downloadButton = d.button({className: 'downloadButton button', type: 'submit'}, _settings.labels.downloadButtonText).activate(function() {
               var button = me.find('.downloadButton');
               var buttonText = _settings.labels.downloadButtonText;
               me.trigger('ListLoaderWidget.GA', {action: 'Download'});
               me.trigger('ListLoaderWidget.DownloadRoster', {button: button, buttonText: buttonText});
          });
          return downloadButton;
     };

     var _drawUploadForm = function(buttonText) {
          var uploadButton = d.button({ className: 'uploadButton button', type: 'submit'}, buttonText);
          // fileSelect below is hidden so that file select can happen by clicking on the uploadButton
          var fileSelect = d.input({ className: 'fileSelect', name: 'file', type: 'file'}).hide();

          uploadButton.click(function() {
               fileSelect.click();
          });

          fileSelect.change(function() {
               _uploadList();
          });

          return [uploadButton, fileSelect];
     };

     var _drawUploadError = function() {
          var errorStatement = d.div({ className: 'errorStatement'}, _settings.labels.errorText);
          var errorExplanation = d.ul({ className: 'errorExplanation'}, _settings.labels.errorExplanationTitleText,
               d.li(_settings.labels.errorExplanationOneText),
               d.li(_settings.labels.errorExplanationTwoText),
               d.li(_settings.labels.errorExplanationThreeText),
               d.li(_settings.labels.errorExplanationFourText),
               d.li(_settings.labels.errorExplanationFiveText)
          );

          return [errorStatement, errorExplanation];
     };

     var _drawErrorOnUpload = function() {
          me.trigger('ListLoaderWidget.DrawUploadError');
     };

     var _getFile = function() {
          var file = me.find('.fileSelect').prop('files')[0];
          var formData = new FormData();
          formData.append('excelFile', file, file.name);
          return formData;
     };

     var _uploadList = function() {
          var data = {
               file: _getFile(),
               callback: _settings.listLoaderSubmissionResultsWidget,
               errorCallback: _drawErrorOnUpload
          };

          compass.loading.start(me.find('.uploadButton').empty(), { color : '#FFFFFF' });
          me.trigger('ListLoaderWidget.GA', {action: 'Upload'});
          me.trigger('ListLoaderTransferWidget.UploadList', data);
     };

     var _drawWidget = function() {
          if (_settings.listLoaderAllowed === false) {
               var widget = _drawHeader().concat(_drawListLoaderDisabledInstructions()).concat(_drawDownloadButton());
          } else if (_settings.isCutoff) {
               var widget = _drawHeader().concat(_drawDownloadOnlyInstructions()).concat(_drawDownloadButton());
          } else if (_settings.uploadError) {
               var widget = _drawHeader().concat(_drawUploadError()).concat(_drawUploadForm(_settings.labels.uploadButtonErrorText)).concat(_drawCancelButton());
          } else {
               var widget = _drawHeader().concat(_drawSubHeader()).concat(_drawInstructions()).concat(_drawDownloadButton()).concat(_drawUploadForm(_settings.labels.uploadButtonText));
          }
          return widget;
     };

     me.render = function(widgetElem) {
          widgetElem.append(_drawWidget());
     };
}, {
     isCutoff: false,
     listLoaderAllowed: true,
     uploadError: false,
     labels: {
          headerText: "Group Roster",
          subHeaderText: "Review and manage your reservation details using an Excel spreadsheet.",
          downloadOnlyTitleText: "The last date for updating your reservation via the Group Roster has passed.",
          downloadOnlyDetailsText: "You can still download your Group Roster to view your reservation details. It may be possible to make changes online. Click on a hotel to see what updates, if any, can be made with the Room Assignments tool.",
          listLoaderDisabledTitleText: "Review your reservation details using an Excel spreadsheet.",
          listLoaderDisabledDetailsText: "Any changes must be made online. Downloading a new Group Roster will always provide you with the most up-to-date reservation information.",
          errorText: "There was an error attempting to upload your Group Roster.",
          errorExplanationTitleText: "Please make sure:",
          errorExplanationOneText: "- You are using the Group Roster template.",
          errorExplanationTwoText: "- No rows or columns have been removed or re-ordered on the Group Roster spreadsheet.",
          errorExplanationThreeText: "- Cells with grey wording have not been unprotected and edited.",
          errorExplanationFourText: "- The file extension is .xlsx.",
          errorExplanationFiveText: "- The current file has not previously been submitted. If so, you must download a new Group Roster file.",
          cancelButtonText: "Cancel",
          uploadButtonErrorText: "Try Again",
          instructionOneText: "1. Download your current Group Roster.",
          instructionTwoText: "2. Update your group's reservation details.",
          instructionThreeText: "3. Upload your edited roster.",
          instructionFourText: "4. Review roster and resolve any conflicts.",
          instructionFiveText: "5. Submit for processing.",
          noteText: "You must use the provided spreadsheet to upload changes. Updates can be made to names, email addresses, payment details, roommates, and hotel requests. Any cancellations and changes to hotel, room type or dates cannot be made using the spreadsheet. Please make them using our website.",
          downloadButtonText: 'Download Roster',
          uploadButtonText: 'Upload Roster'
     },
     WUID: 'LISTLOADERTRANSFERWIDGET',
     widgetName: 'ListLoaderTransferWidget'
});